import { ResolveFn } from "@angular/router";
import { inject } from "@angular/core";
import { IWebsiteOffer } from "@app/applications/quotation/domains/website-offers/interfaces/website-offer.interface";
import { WebsiteOfferApiService } from "@app/applications/quotation/domains/website-offers/services/website-offer-api.service";

export const viewWebsiteResolverResolver: ResolveFn<IWebsiteOffer> = (route, _) => {
  const websiteOfferApiService = inject(WebsiteOfferApiService);
  return websiteOfferApiService.fetchWebsiteOffer(route.params["id"]);
};
